import {
  GetServerSidePropsContext,
  GetServerSidePropsResult,
  NextPage,
} from "next";

import getArticles from "api/requests/wordpress/getArticles";
import getMenuItems from "api/requests/wordpress/getMenuItems";
import getPages from "api/requests/wordpress/getPages";
import { ArticleExcerpt, MenuItems, Page } from "custom-types/Wordpress";
import { getCountryCodeHeader } from "utils/requestContext";

import ListLayout from "components/news/Layouts/ListLayout";
import PageLayout from "components/news/Layouts/PageLayout";

type Props = {
  menuItems: MenuItems;
  page: Page;
  articles: ArticleExcerpt[];
  totalCount: number;
  totalPages: number;
};

const NewsAllPage: NextPage<Props> = ({
  page,
  articles,
  menuItems,
  totalCount,
  totalPages,
}) => (
  <PageLayout
    menuItems={menuItems}
    page={page}
    currentPage={1}
    totalPages={totalPages}
  >
    <ListLayout
      title="All Articles"
      articles={articles}
      totalCount={totalCount}
      currentPage={1}
      totalPages={totalPages}
      path="/news/all"
    />
  </PageLayout>
);

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
): Promise<GetServerSidePropsResult<Props>> => {
  const countryCode = getCountryCodeHeader(context.req.headers);

  const { pages } = await getPages(countryCode, { slug: "all" }, "1", "1");

  const page = pages?.[0];
  if (!page) {
    return {
      notFound: true,
    };
  }

  const [{ articles, totalCount, totalPages }, menuItems] = await Promise.all([
    getArticles(countryCode),
    getMenuItems(countryCode !== "CA" ? "canada" : "global"),
  ]);

  return {
    props: {
      articles: articles as ArticleExcerpt[],
      menuItems,
      page,
      totalCount,
      totalPages,
    },
  };
};

export default NewsAllPage;
